<script>
// CommitChart.js
import { Scatter, mixins } from 'vue-chartjs'

export default {
  extends: Scatter,
  mixins: [mixins.reactiveProp],
  props: ['chartData', 'options'],
  mounted () {
    this.renderChart(this.chartData, this.options)
  },
  methods: {
    getCtx () {
      return this._data._chart.ctx
    },
    getController () {
      return this._data._chart.controller
    }
  }
}
</script>
